export function checkWebpCanvas() {
  let support = false;
  try {
    const canvas = document.createElement('canvas');
    const dataUrl = canvas.toDataURL('image/webp');

    support = dataUrl.startsWith('data:image/webp');
  } catch (e) {
    support = false;
  }
  window.supportWebp = support;
  return support;
}


export function checkBrowserSupports(){
  checkWebpCanvas()
}


// WEBPACK FOOTER //
// ./src/utils/browser.js